import React, { Suspense } from "react";

type TextEditorModule = typeof import("./TextEditorInner");
export type TextEditorProps = Parameters<TextEditorModule["TextEditor"]>[0];

const LazyTextEditor = React.lazy(() =>
  import("./TextEditorInner").then((mod) => ({
    default: mod.TextEditor,
  })),
);

export const TextEditor = (props: TextEditorProps) => {
  return (
    <Suspense
      fallback={
        <div className="min-h-32 rounded-xl border border-slate-400 bg-white px-3.5 py-3 text-sm text-slate-500 shadow-xs">
          Loading editor…
        </div>
      }
    >
      <LazyTextEditor {...props} />
    </Suspense>
  );
};

export default TextEditor;
